<template>
    <div v-if="group">
        <b-modal
            size="md"
            v-model="modalShow"
            title="利用再開"
            @ok="handleOk"
            @cancel="close"
            @hidden="close">
            <div class="vc-box">
                <div><span class="text-muted">{{ groupTypeName }}番号：</span>{{ group.id }}</div>
                <div><span class="text-muted">{{ groupTypeName }}名：</span>{{ group.name }}</div>
            </div>

            <p class="text-center mt-4">上記の{{ groupTypeName }}を利用再開します。よろしいですか？</p>

            <div
                slot="modal-footer"
                class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <div class="d-flex justify-content-center">
                    <button
                        class="btn btn-yokumiru-gray mr-2"
                        :disabled="inProgress"
                        @click="close">
                        キャンセル
                    </button>
                    <button
                        class="btn btn-yokumiru-outline-blue"
                        :disabled="inProgress"
                        @click="handleOk">
                        利用再開
                    </button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import constants from '../../../../constants'
import YokumiruHelper from '../../../../YokumiruHelper'

export default {
    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            group: null,
        }
    },

    computed: {
        groupTypeName: function () {
            if (!this.group) return ''
            return this.helper.groupTypeName(this.group.group_type)
        },
    },

    created: function () {
        bus.$on('open-modal-admin-resume-group', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-admin-resume-group')
    },

    methods: {
        /**
         * モーダル表示
         *
         * @param {object} group
         */
        open: function (group) {
            this.group = {...group}
            this.modalShow = true
        },

        /**
         * モーダルを閉じる
         */
        close: function () {
            this.modalShow = false
        },

        /**
         * 利用再開ボタン押下時
         *
         * @param {object} e
         */
        handleOk: function (e) {
            e.preventDefault()
            this.resumeGroup()
        },

        /**
         * グループ利用再開
         */
        resumeGroup: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.groups.endpoint.base

            await axios.put(`${endpoint}/${this.group.id}/resume`)
                .then(() => {
                    bus.$emit('alert-success', `${this.groupTypeName}を利用再開しました。`)
                    bus.$emit('fetch-group')
                    this.close()
                })
                .catch(({response}) => {
                    if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                        bus.$emit('alert-danger', response.data.errors.message[0])
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },
    },
}
</script>

<style scoped lang="scss">
.vc-box {
    padding: 15px;
    background: #eceff1;
    border-radius: 6px;
}
</style>
